import { FormattedMessage } from "react-intl";

import Section from "common/details/grid/section";
import Row from "common/details/grid/row";

export function ProofRequirements({
  ial2Proof,
  smsProof,
  kbaProof,
}: {
  ial2Proof: boolean | undefined;
  smsProof: boolean | undefined;
  kbaProof: boolean | undefined;
}) {
  return (
    <Section>
      <Row
        title={
          <FormattedMessage
            id="cf127065-db35-426b-816b-cda139400225"
            defaultMessage="Identity proofing"
          />
        }
      >
        {ial2Proof && (
          <FormattedMessage
            id="24df835f-5fca-463c-8c2e-40dc2d28c60a"
            defaultMessage="IAL-2 compliant identity verification{comma, select, true {,{br}} other {}}"
            values={{ comma: smsProof || kbaProof, br: <br /> }}
          />
        )}
        {smsProof && (
          <FormattedMessage
            id="3ec75d63-fd4a-41f2-8a48-8dc53bb04039"
            defaultMessage="SMS authentication{comma, select, true {,{br}} other {}}"
            values={{ comma: kbaProof, br: <br /> }}
          />
        )}
        {kbaProof && (
          <FormattedMessage
            id="2b0fddd3-6ea5-44d2-be82-38548c7a07ea"
            defaultMessage="Knowledge-based authentication (KBA)"
          />
        )}
      </Row>
    </Section>
  );
}
